<template>
  <div class="Header">


    <div class="header_red" v-if="Header_red"> </div>
    <div class="header_red1" v-else-if="Header_red1"> </div>
    <div class="HeaderMain" v-else>
      <div class="wrap">
        <div class="HeaderLogo">
          <a href="/" class="logo fl"><img src="~@/assets/images/navbar/logo.png" alt="logo" /></a>
        </div>
        <div class="topr">
          <div class="search">
            <p>
              <a href="http://oa.ccaa.org.cn">OA入口</a>
              <a class="lr" href="http://mail.ccaa.org.cn/">办公邮箱</a>
            </p>
            <el-input v-model="searchText" clearable placeholder="请输入关键字查询" class="search-input">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </div>
          <h3>全方位服务行业发展</h3>
        </div>
        <div class="menu-wrap">
          <div class="btn-nav menu-btn j_menu-btn" alt="1">
            <span class="icon-bar top"></span>
            <span class="icon-bar middle"></span>
            <span class="icon-bar bottom"></span>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <div :class="nav_red ? 'navs_red' : 'navs'">
      <ul class="wrap">
        <li :class="{ active: 0 === activeIndex }">
          <a class="a1" href="/">首页</a>
        </li>
        <div v-for="(item, index) in treeList" :key="index" :class="{ active: item.id === activeIndex }">
          <li v-if="item.status == 1" :class="item.id == 155 ? 'fj20' : ''">
            <a class="a2" :hre="item.pagetpl" @click="updateProductUrl(item)" :style="{
              backgroundImage: 'url(' + item.pcIconUrl + ')',
            }">{{ item.name }}</a>
            <div class="ernav">
              <a class="er" v-for="(item2, index2) in item.children" :key="index2" @click="updateProductUrl(item2)"
                v-if="item2.status == 1">{{ item2.name }}</a>
            </div>
          </li>
        </div>

      </ul>
    </div>
  </div>
</template>

<script>
import bus from '@/assets/js/bus.js'
import { cmsChannelTreeList } from '@/api/nav'
export default {
  name: 'Home',
  data () {
    return {
      treeList: [],
      activeIndex: 0,
      Header_red: false,
      Header_red1: false,
      nav_red: false,
      searchText: ""
    }
  },
  // watch: {
  //   '$route' (to, from) {
  //     // 在这里可以处理路由跳转的逻辑
  //     console.log('路由已变更，从', from.path, '到', to.path);
  //     this.searchText = ""
  //   }
  // },
  created () {
    var _this = this
    this.getnavList()
  },

  mounted () {
    this.searchText = localStorage.getItem('keyword')
    bus.$on('navkey', (res) => {
      var _this = this
      _this.activeIndex = res.id
      if (res.id == 140 || res.parentId == 140) {
        _this.Header_red = true
        _this.nav_red = true
      } else if (res.id == 155 || res.parentId == 155) {
        _this.Header_red1 = true
        _this.nav_red = true
      } else {
        _this.Header_red = false
        _this.Header_red1 = false
        _this.nav_red = false
      }
    })

  },

  methods: {
    getnavList () {
      var _this = this

      cmsChannelTreeList()
        .then((res) => {
          if (res.code == 0) {
            _this.treeList = res.data
          }
        })
        .catch((res) => { })
    },
    updateProductUrl (item) {
      console.log(item);
      var _this = this
      if (item.id == 140 || item.parentId == 140) {
        _this.Header_red = true
        _this.Header_red1 = false
        _this.nav_red = true
      } else if (item.id == 155 || item.parentId == 155) {
        _this.Header_red1 = true
        _this.Header_red = false
        _this.nav_red = true
      } else {
        _this.Header_red = false
        _this.Header_red1 = false
        _this.nav_red = false
      }

      if (item.webLayout == 2) {
        window.open(item.outlink)
        return
      } else {
        this.$router.push({ path: item.pagetpl })
      }
      // this.$router.push({ path: item.pagetpl })
    },
    handleSearch () {
      if (this.searchText == "" || this.searchText == null || this.searchText.trim().length === 0) {
        this.$message.error('请输入关键词');
      } else {
        if (this.$route.path != '/search') {
          this.$router.push(`/search`);
          localStorage.setItem('keyword', this.searchText.trim());
        } else {
          this.$router.push(`/home`);
          localStorage.setItem('keyword', this.searchText.trim());
          setTimeout(() => {
            this.$router.push(`/search`);
          }, 100);
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-input__inner {
  height: 26px;
  line-height: 26px;
  font-size: 12px;
}

/deep/.el-input__suffix {
  position: absolute;
  right: 8px;
  top: -5px;
  /* 负值越大上移越多 */
  transform: translateY(-10%);
}

.Header {
  width: 100%;
  background: #fff;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);

  .header_red {
    width: 100%;
    height: 520px;
    background: url('~@/assets/images/navbar/navbg_ztjy.png') no-repeat center;
  }

  .header_red1 {
    width: 100%;
    height: 498px;
    background: url('~@/assets/images/navbar/navbg_1.png') no-repeat center;

  }

  .HeaderMain {
    width: 100%;
    height: 230px;
    background: url('~@/assets/images/navbar/topbg.jpg') no-repeat center;

    .HeaderLogo {
      width: 397px;
      height: 98px;
      margin: 70px 0 59px 0;
      position: relative;
      float: left;

      img {
        height: 100%;
        vertical-align: top;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    .topr {
      margin: 60px 0;
      float: right;

      .search {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        p {

          a {
            height: 14px;
            line-height: 14px;
            padding: 0 10px;
            margin: 8px 0;
            display: block;
            float: left;
            font-size: 14px;
            color: #1b51a8;
          }

          .lr {
            border-left: 1px solid #1b51a8;
          }
        }

        .search-input {
          width: 198px;
          height: 26px;
          background: url('~@/assets/images/navbar/40.png') repeat;
          border: 1px solid #1b51a8;
          border-radius: 3px;
          float: right;

          .txt {
            width: 198px;
            height: 26px;
            line-height: 26px;
            padding-left: 10px;
            float: left;
          }

          .sub {
            width: 28px;
            height: 28px;
            line-height: 28px;
            background: url('~@/assets/images/navbar/serbg.png') no-repeat center;
            cursor: pointer;
            float: left;
          }
        }
      }

      h3 {
        line-height: 56px;
        margin-top: 10px;
        font-size: 56px;
        font-weight: normal;
        font-family: '华文行楷';
        color: #1b51a8;
      }
    }
  }

  .navs {
    width: 100%;
    height: 50px;
    background: #1b51a8;
    position: relative;

    .fj20 {
      // background: url('~@/assets/images/navbar/fj20.png') no-repeat center;

      .a2 {
        // opacity: 0;
        font-weight: 600;
        color: #F1FF00;
        font-size: 18px;
        background: no-repeat 0 center;

      }
    }

    ul {
      height: 100%;
      width: 1300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      li {
        width: 117px;
        height: 50px;
        cursor: pointer;
        position: relative;

        .ernav {
          width: 100px;
          overflow: hidden;
          position: absolute;
          top: 50px;
          background: url('~@/assets/images/navbar/90.png') repeat;
          border: 1px solid #3160ae;
          border-bottom: 3px solid #3160ae;
          display: none;
          z-index: 999;

          a {
            height: auto;
            line-height: 20px;
            text-align: center;
            padding: 12px 0;
            font-size: 16px;
            color: #333;
            border-bottom: 1px solid #8d9bca;
          }

          a:hover {
            color: #1b51a8;
          }
        }

        a {
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          display: block;
        }

        .a1 {
          background: url('~@/assets/images/navbar/abg1.png') no-repeat 22px center;
        }

        .a2 {
          background: no-repeat 10px center;
        }
      }

      li.active {
        background: url('~@/assets/images/navbar/navbg.png') no-repeat center;
      }



      li:hover {
        background: url('~@/assets/images/navbar/navbg.png') no-repeat center;
        // background: url('~@/assets/images/navbar/fj20.png') no-repeat center;

        .ernav {
          width: 100px;
          position: absolute;
          top: 50px;
          left: 0;
          background: url('~@/assets/images/navbar/90.png') repeat;
          display: block;
        }
      }
    }
  }


  .navs_red {
    width: 100%;
    height: 50px;
    background: #E10900;
    position: relative;

    .fj20 {
      background: url('~@/assets/images/navbar/fj20.png') no-repeat center;


      .a2 {
        opacity: 0;
        background: no-repeat 0 center;
      }
    }

    .fj20.active {
      background: url('~@/assets/images/navbar/fj20.png') no-repeat center;

    }

    .fj20:hover {
      background: url('~@/assets/images/navbar/fj20.png') no-repeat center;


    }

    ul {
      height: 54px;
      width: 1300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      li {
        width: 117px;
        height: 50px;
        cursor: pointer;
        position: relative;

        .ernav {
          width: 100px;
          overflow: hidden;
          position: absolute;
          top: 50px;
          left: 0;
          background: url('~@/assets/images/navbar/90.png') repeat;
          border: 1px solid #FD0000;
          border-bottom: 3px solid #FD0000;
          display: none;
          z-index: 999;

          a {
            height: auto;
            line-height: 20px;
            text-align: center;
            padding: 12px 0;
            font-size: 16px;
            color: #333;
            border-bottom: 1px solid #FD0000;
          }

          a:hover {
            color: #FD0000;
          }
        }

        a {
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          display: block;
        }

        .a1 {
          background: url('~@/assets/images/navbar/abg1.png') no-repeat 22px center;
        }

        .a2 {
          background: no-repeat 10px center;
        }
      }

      li.active {
        background: url('~@/assets/images/navbar/top-nav-red-bg.png') no-repeat center;
      }

      .li_1.active {
        background: url('~@/assets/images/navbar/top-nav-red-bg.png') no-repeat center;
      }

      li:hover {
        background: url('~@/assets/images/navbar/top-nav-red-bg.png') no-repeat center;

        .ernav {
          width: 100px;
          position: absolute;
          top: 50px;
          left: 0;
          background: url('~@/assets/images/navbar/90.png') repeat;
          display: block;
        }
      }
    }
  }
}

.menu-wrap {
  position: relative;
  right: 0px;
  float: right;
  top: 32px;
  z-index: 99999;
  cursor: pointer;
  display: block;
}

.menuMain {
  display: none;
}

.menu-content {
  display: none;
}
</style>
